import { MutableRefObject } from "react";
import { Extension } from "@tiptap/core";

export type OpenLinkPopover = (params: {
  anchorRect: DOMRect;
  href: string;
  displayText: string;
}) => void;

export const createLinkKeyboardShortcutExtension = (
  openLinkPopoverRef: MutableRefObject<OpenLinkPopover | null>,
) =>
  Extension.create({
    name: "linkKeyboardShortcut",
    addKeyboardShortcuts() {
      return {
        "Mod-k": () => {
          const { from, to, empty } = this.editor.state.selection;
          const displayText = empty
            ? ""
            : this.editor.state.doc.textBetween(from, to);
          const fromCoords = this.editor.view.coordsAtPos(from);
          const toCoords = this.editor.view.coordsAtPos(to);
          openLinkPopoverRef.current?.({
            href: this.editor.getAttributes("link").href ?? "",
            displayText,
            anchorRect: new DOMRect(
              fromCoords.left,
              fromCoords.top,
              toCoords.right - fromCoords.left,
              toCoords.bottom - fromCoords.top,
            ),
          });
          return true;
        },
      };
    },
  });
